export default class {
  isValid(value) {
    return !!value;
  }
}
